
import ApiResponse from "sr/models/ApiResponse";
import { get } from "sr/utils/axios";

export const getBenefits = async () => {
  return await get<ApiResponse<any[]>>("/benefits").then((res)=>{
      return res
    })
};

 